import React, { useState, useEffect } from 'react';
import FullPagePreloader from '../FullPagePreloader';
import { toHoursAndMinutes } from '../../../utils/time';

import BoardStatistic from './BoardStatistic';
import styled from 'styled-components';

const GeneralTime = styled.div`
  display: flex;
  justify-content: space-between;
  .back {
    font-size: 15px;
    color: #999;
    cursor: pointer;
  }
  align-items: center;
  font-size: 30px;
  margin-bottom: 10px;
`;

const StatisticWrapper = styled.div`
  background: #fff;
  position: relative;
`;

const UserStatistic: React.FC<{
  currentUserId: string;
  day: number;
  resetDay: () => void;
  loading: boolean;
  invitations: { title: string; id: string }[];
}> = (props) => {
  const [totalSecondsPerBoard, setTotalSecondsPerBoard] = useState<Record<string, number>>({});
  const [totalSeconds, setTotalSeconds] = useState<number>(0);

  useEffect(() => {
    if (totalSecondsPerBoard) {
      const total = Object.keys(totalSecondsPerBoard).reduce((prev, cur) => {
        return prev + totalSecondsPerBoard[cur];
      }, 0);
      setTotalSeconds(total);
    }
  }, [totalSecondsPerBoard]);

  return (
    <StatisticWrapper>
      {props.loading ? (
        <FullPagePreloader />
      ) : (
        <>
          {!!totalSeconds && (
            <GeneralTime>
              <span className="back" onClick={props.resetDay}>
                ← Назад
              </span>
              <div>
                Общее время - <b>{toHoursAndMinutes(totalSeconds)}</b>
              </div>
            </GeneralTime>
          )}
          {props.invitations?.map((inv) => {
            return (
              <BoardStatistic
                day={props.day}
                key={inv.id}
                boardTitle={inv.title}
                boardId={inv.id}
                userId={props.currentUserId}
                setTotalSecondsPerBoard={(boardId, seconds) =>
                  setTotalSecondsPerBoard({ ...totalSecondsPerBoard, [boardId]: seconds })
                }
              />
            );
          })}
        </>
      )}
    </StatisticWrapper>
  );
};

export default UserStatistic;
